<template>
    <div>
        <h1 style="font-size: 24px; color: black;">物品管理</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                <el-form-item label="应用：">
                    <el-select v-model="queryData.appType" :clearable="true">
                        <el-option
                                v-for="item in iosAppList"
                                :label="item.appName"
                                :value="item.appId"
                                :key="item.appId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物品类型：">
                    <el-cascader
                            v-model="queryData.cid"
                            :options="cgCategoryList"
                            :props="{emitPath: false,value:'cid',label:'name',multiple: true}"
                            clearable></el-cascader>
                </el-form-item>
                <el-form-item label="物品名称：">
                    <el-input v-model="queryData.name" style="width: 200px" placeholder="请输入物品名称"></el-input>
                </el-form-item>
                <el-form-item label=" " class="sub-sub11">
                    <el-button type="primary" @click="queryList">查询</el-button>
                    <el-button type="primary" @click="showDetails('创建')">创建</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px"
                   :close-on-click-modal="false">
            <el-form :model="form.formData" label-width="150px">
                <el-form-item label="应用:">
                    <el-select v-model="form.formData.appType">
                        <el-option
                                v-for="item in iosAppList"
                                :label="item.appName"
                                :value="item.appId"
                                :key="item.appId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物品类型:">
                    <el-cascader
                            v-model="form.formData.cid"
                            :options="cgCategoryList"
                            :props="{emitPath: false,value:'cid',label:'name'}"
                            clearable></el-cascader>
                </el-form-item>
                <el-form-item label="物品等级:">
                    <el-select v-model="form.formData.level">
                        <el-option
                                v-for="item in cgGoodLevelList"
                                :label="item.name"
                                :value="item.id"
                                :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物品名称:" prop="name">
                    <el-input style="width: 300px" type="text" v-model="form.formData.name"></el-input>
                </el-form-item>
                <el-form-item label="资源:" prop="resource">
                    <el-input style="width: 300px" type="text" v-model="form.formData.resource"></el-input>
                </el-form-item>
                <el-form-item label="物品描述:" prop="description">
                    <el-input style="width: 300px" type="textarea" :rows="5"
                              v-model="form.formData.description"></el-input>
                </el-form-item>
                <el-form-item label="图片url :" :label-width="labelWidth">
                    <el-upload :headers="headers"
                               class="avatar-uploader"
                               :action="uploadURL"
                               :show-file-list="false"
                               :on-success="handleCISuccess"
                               :before-upload="beforeAvatarUpload"
                    >
                        <img v-if="form.formData.imageUrl" :src="VUE_APP_CDN_URL+form.formData.imageUrl" class="avatar">
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="视频url :" :label-width="labelWidth">
                    <el-upload :headers="headers"
                               class="avatar-uploader"
                               :action="uploadURL"
                               :show-file-list="false"
                               :on-success="handleVideoSuccess"
                               :before-upload="beforeVideoUpload">
                        <video v-if="form.formData.videoPath" :src="VUE_APP_CDN_URL+form.formData.videoPath"
                               class="avatar1"
                               controls="controls"/>
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="备注:" prop="remark">
                    <el-input style="width: 300px" type="textarea" :rows="5" v-model="form.formData.remark"></el-input>
                </el-form-item>
                <el-form-item label="是否vip专用 :">
                    <el-radio-group v-model="form.formData.isVip">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="状态:" prop="status">
                    <el-input style="width: 300px" type="textarea" :rows="5" v-model="form.formData.status"></el-input>
                </el-form-item>
                <el-form-item label="持续时长单位分钟:" prop="status">
                    <el-input-number  :min="0" :max="9999999" style="width: 220px" type="text" v-model="form.formData.duration"> </el-input-number>
                </el-form-item>
                <el-form-item label="经验值:" prop="status">
                    <el-input-number  :min="0" :max="9999999" style="width: 220px" type="text" v-model="form.formData.expNumber"> </el-input-number>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirm">确 定</el-button>
                    <el-button type="info" @click="cancel">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="视频详情"
                   center
                   :visible.sync="videoDialogVisible"
                   @close="videorDialogVisible=false"
                   width="320px">
            <div>
                <video :src="VUE_APP_CDN_URL+this.videoTmpePath" style="width: 270px; height: 480px" class="avatar1"
                       controls="controls"/>
            </div>
        </el-dialog>
        <h1>
            <el-table border :data="dataList">
                <el-table-column label="id" prop="id"></el-table-column>
                <el-table-column label="应用" prop="appType" >
                    <template slot-scope="scope">
                        {{ scope.row.appType | commonFilter(iosAppObj)}}
                    </template>
                </el-table-column>
                <el-table-column label="物品类型" prop="cid" :formatter="transform" width="140px" align="center"></el-table-column>
                <el-table-column label="物品等级" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.level === 0">普通</div>
                      <div v-if="scope.row.level === 1">高级</div>
                      <div v-if="scope.row.level === 2">豪华</div>
                    </template>
                </el-table-column>
                <el-table-column label="名称" prop="name" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.name }}
                    </template>
                </el-table-column>
                <el-table-column label="描述" prop="description" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.description }}
                    </template>
                </el-table-column>
                <el-table-column label="图片" align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.imageUrl" width="60px" height="60px"/>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="视频">
                    <template slot-scope="scope" v-if="scope.row.videoPath">
                        <el-button type="text" @click="showVideo(scope.row)">查看视频</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="资源" prop="resource">
                    <template slot-scope="scope">
                        {{ scope.row.resource }}
                    </template>
                </el-table-column>
                <el-table-column label="经验值" prop="expNumber">
                    <template slot-scope="scope">
                        {{ scope.row.expNumber }}
                    </template>
                </el-table-column>
                <el-table-column label="持续时长(分)" prop="duration">
                    <template slot-scope="scope">
                        {{ scope.row.duration }}
                    </template>
                </el-table-column>
                <el-table-column label="是否vip专用" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isVip === true">是</span>
                        <span v-if="scope.row.isVip === false">否</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" prop="createDt" width="160px">
                    <template slot-scope="scope">
                        {{ scope.row.createDt | dateTimeFormat}}
                    </template>
                </el-table-column>
                <el-table-column label="更新时间" prop="updateDt" width="160px">
                    <template slot-scope="scope">
                        {{ scope.row.updateDt | dateTimeFormat}}
                    </template>
                </el-table-column>
                <el-table-column label="备注" prop="remark" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.remark }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150px">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="primary" @click="showDetails('编辑',scope.row)">编辑</el-button>
                        <el-button plain size="mini" type="danger" @click="removeConfig(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page.page"
                        :page-sizes="[1,10,20,30,50]"
                        :page-size="page.size"
                        layout="total, sizes, prev, pager, next"
                        :total="page.totalElements">
                </el-pagination>
            </el-row>
        </h1>

    </div>
</template>

<script>
    import {
        deleteGood,
        updateGood,
        searchGood,
    } from "@/http/cgApi";
    import {goodTypes} from '@/constants/common/basic-data'
    import settingMix from '@/utils/mix/common-setting'
    import objUtil from '@/utils/ObjUtil'
    import store from '@/store'

    export default {
        name: "CgGoods",
        mixins: [settingMix],
        data() {
            return {
                versionCode: store.state.newProjectVersion.selectedVersion,
                appType: '' + store.state.newProjectVersion.selectedAppType,
                needIosApp: true,
                iosAppObj: {},
                iosAppList: [],
                goodTypes: goodTypes,
                labelWidth: '200px',
                headers: {},
                uploadURL: process.env.VUE_APP_IOS_URL + "block/upload",
                videoDialogVisible: false,
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
                dialogVisible: false,
                dialogTitle: '',
                queryData: {
                    sys: "",
                    appType: "",
                },
                dataList: [],
                form: {
                    createData: {
                        "id": null,
                        "appType": '',
                        "type": '',
                        "name": '',
                        "description": '',
                        "imageUrl": '',
                        "videoPath": '',
                        "remark": '',
                        "cid":'',
                        "status": '',
                        "createDt": '',
                        "updateDt": '',
                        "level":0,
                        "duration":0,
                        "resource":'',
                        "resourceVersion":0,
                        "isVip":false
                    },
                    formData: {},
                },
                VUE_APP_IOS_URL: '',
                VUE_APP_CDN_URL: '',
                videoTmpePath: '',
                cgCategoryList:[],
                cgCategoryAll:[],
                cgGoodLevelList:[],
                needCgCategoryInfo:true,
                needCgCategoryAll:true,
                needCgGoodLevel:true,
            }
        },
        methods: {
            handleSizeChange(size) {
                this.page.size = size;
                this.queryList();
            },
            transform:function(row){
                // console.log(this.iosBookCategoryList)
                const arr = this.cgCategoryAll;
                var parent;
                var child = arr.filter(it => it.cid === row.cid);
                if (child.length>0) {
                    if (child[0].parentCid !== 0) {
                        parent = arr.filter(item => item.cid === child[0].parentCid);
                        return parent[0].name + '/' + child[0].name;
                    }else{
                        // console.log(child)
                        return child[0].name;
                    }
                }
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.queryList();
            },
            showDetails(title, row) {
                this.form.formData = objUtil.clone(this.form.createData)
                this.dialogTitle = title;
                this.dialogVisible = true;
                if (row) {
                    this.form.formData = objUtil.clone(row)
                    // console.log(this.form.formData)
                }
            },
            confirm() {
                let _message = '';
                if (this.form.formData.appType === '') {
                    _message = '请选择应用'
                } else if (this.form.formData.versionCode === '') {
                    _message = '请填写备注，以防忘记配置内容'
                }
                if (_message) {
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                updateGood(this.form.formData).then(resp => {
                    if (resp.data.status === 0) {
                        this.queryList();
                        this.dialogVisible = false;
                    }
                })
            },
            cancel() {
                this.dialogVisible = false;
            },
            removeConfig(id) {
                this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteGood(id).then(resp => {
                        if (resp.data.status === 0) {
                            this.queryList();
                        }
                    });
                }).catch(() => {
                })
            },
            queryList() {
                let queryTrueData = {
                    appType: this.queryData.appType,
                    cid: this.queryData.cid,
                    name: this.queryData.name
                };
                queryTrueData = Object.assign(queryTrueData, this.page)
                searchGood(queryTrueData).then(resp => {
                    if (resp.data.status === 0) {
                        this.dataList = resp.data.info.content;
                        this.page.totalElements = resp.data.info.totalElements;
                    }
                })
            },
            beforeAvatarUpload(file) {
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过1MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            beforeVideoUpload(data) {
                const type = data.name.substring(data.name.lastIndexOf('.')) === '.mp4' || data.name.substring(data.name.lastIndexOf('.')) === '.mov';
                const size = data.size < 1024 * 1024 * 20;
                if (!type) {
                    this.$message.error('上传视频只能是mp4/mov格式!');
                }
                if (!size) {
                    this.$message.error('上传视频大小不能超过20m!');
                }
                return type && size;
            },
            handleCISuccess(response) {
                this.form.formData.imageUrl = response.info;
            },
            handleVideoSuccess(data) {
                this.form.formData.videoPath = data.info;
            },
            videoInfo: function () {
                return this.form.formData;
            },
            showVideo: function (data) {
                this.videoDialogVisible = true;
                this.videoTmpePath = data.videoPath;

            },
        },
        created() {
            this.headers = {Authorization: this.$store.state.user.token}
            this.queryList();

        },
        mounted() {
            // document.body.ondrop = function (event) {
            //     event.preventDefault();
            //     event.stopPropagation();
            // };
            // this.rowDrop();
            this.VUE_APP_IOS_URL = process.env.VUE_APP_IOS_URL;
            this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>

</style>
